import { HttpClient } from '@angular/common/http';
import {  Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import * as _ from 'lodash';


@Injectable({
    providedIn: 'root',
})
export class TestService {


    constructor(
        private http: HttpClient
    ) { }


    getAllTest() {
        return this.http.get<any>(
            `${environment.apiUrl}/test/`
            
        );
    }

}
